<script setup lang="ts">
import Link from '@/components/Link.vue';

const props = defineProps<{
    fields: { title: string; value: string; routeTo?: string }[];
    textClasses?: string;
}>();
</script>

<template>
    <section>
        <v-row v-for="field in props.fields" :key="field.title" class="align-center ga-10">
            <v-col md="3" cols="5" class="pa-0">
                <p class="font-weight-bold" :class="textClasses ?? textClasses">{{ field.title }}</p>
            </v-col>
            <v-col md="4" cols="4" class="pa-0" v-if="field.routeTo">
                <Link :routeTo="field.routeTo" :displayText="field.value" icon="person" />
            </v-col>
            <v-col md="8" cols="8" class="pa-0" v-else :class="textClasses ?? textClasses">
                <p class="pa-0">{{ field.value }}</p>
            </v-col>
        </v-row>
    </section>
</template>
